<template>
  <mu-card id="lifeRecommendations" v-if="data.length">
    <mu-card-header
      titleClass="blueTitle largeTitle"
      :title="$t('message.lifeCategoryListsHeaderText')"
      :subTitle="$t('message.lifeCategoryListsSubHeaderText')">
    </mu-card-header>
    <mu-list v-if="isLoading">
      <mu-list-item
        v-for="item, index in dummyLoaders"
        :key="'dummy-loader-' + index"
      >
        <mu-linear-progress slot="describe" color="#d9d9d9 "
                            style="width: 50%; height: 12px;background: rgb(214, 214, 214); margin-bottom: 8px"></mu-linear-progress>

        <mu-linear-progress slot="describe" color="#d9d9d9 "
                            style="width: 16%; height: 12px;background: rgb(214, 214, 214); margin-bottom: 8px"></mu-linear-progress>

      </mu-list-item>
    </mu-list>
    <mu-list>
      <mu-list-item
        v-for="item, index in data"
        v-if="!isLoading && !item.post_private"
        :key="'life-category-post-' + index"
      >
        <div slot="title" class="title" @click="goTo(item.post_slug)">
          <div class="blueTitle" v-html=$sanitize(item.post_title + ' &#8594')"></div>
        </div>
        <mu-avatar @click.native="goTo(item.post_slug)" :size="50" :src="item.post_image || ''" slot="left" color="white" backgroundColor="#E9E9E8"></mu-avatar>
        <div slot="describe">
          <mu-flat-button @click.native="favouritePost(item.post_id, index)" class="btn-outline" rippleColor="#E74C3C" :disabled="!userId">
            <span class="mu-icon material-icons" v-text="item.post_favourited ? 'favorite' : 'favorite_border'"></span>
            <span v-text="item.post_favourites"></span>
          </mu-flat-button>
        </div>
      </mu-list-item>
    </mu-list>
  </mu-card>
</template>
<script>
  import config from '../../../config/index';
  import LifeStyleApi from '../../../api/LifeStyle';
  
  export default {
    name: "life-category-list",
    props: {
      postId: {
        type: Number,
        required: true,
      }
    },
    data () {
      return {
        isLoading: true,
        isSaving: false,
        limit: 5,
        dummyLoaders: [
          {},
          {},
          {},
          {},
          {},
        ],
        data: []
      }
    },
    mounted() {
      let self = this;
      self.isLoading = true;
      LifeStyleApi.getRecommendationsByPost(self.postId, self.userId, self.limit).then((response) => {
        self.isLoading = false;
        self.data = response.data;
      });
    },
    methods: {
      favouritePost(post_id, index) {
        let self = this;
        LifeStyleApi.favouritePost({
          post_id: post_id
        }).then((res) => {
          const callback = res.data;
          if (callback.fav_status) {
            self.data[index].post_favourited = true;
            self.data[index].post_favourites += 1;
          } else {
            self.data[index].post_favourited = false;
            self.data[index].post_favourites -= 1;
          }
        });
      },
      goTo (slug) {
          let self = this;
        self.$router.push({
          path: '/life/' + slug
        })
      },
    },
    computed: {
      userId() {
        let self = this;
        if (self.$store.state.user.scope) {
          return self.$store.state.user.scope.user_id;
        }
        return false;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LifeCategoryList.vue?34147b17